export const replyWithAttachmentLastModifiedText = "nIb";
export const accessedOnText = "oIb";
export const replyWithMenuHeaderText = "pIb";
export const suggestedFilesText = "qIb";
export const suggestedAttachmentsReceivedFromText = "rIb";
export const suggestedAttachmentsReceivedFromAgoText = "sIb";
export const suggestedAttachmentsReceivedAgoText = "tIb";
export const suggestedAttachmentsOnText = "uIb";
export const suggestedAttachmentsOnOnedriveText = "vIb";
export const suggestedAttachmentsModifiedByText = "wIb";
export const suggestedAttachmentsCreatedByOwnerText = "xIb";
export const suggestedAttachmentsSentText = "yIb";
export default {replyWithAttachmentLastModifiedText,accessedOnText,replyWithMenuHeaderText,suggestedFilesText,suggestedAttachmentsReceivedFromText,suggestedAttachmentsReceivedFromAgoText,suggestedAttachmentsReceivedAgoText,suggestedAttachmentsOnText,suggestedAttachmentsOnOnedriveText,suggestedAttachmentsModifiedByText,suggestedAttachmentsCreatedByOwnerText,suggestedAttachmentsSentText};